export enum CoachSettings {
  POST_CUSTOM_IMAGES = "POST_CUSTOM_IMAGES",
  POST_CUSTOM_MESSAGE = "POST_CUSTOM_MESSAGE",
  POST_IN_FB = "POST_IN_FB",
  POST_IN_IG = "POST_IN_IG",
  POST_IN_TW = "POST_IN_TW",
  POST_IN_TT = "POST_IN_TT",
  POST_IN_LI = "POST_IN_LI",
  POST_IN_IG_STORY = "POST_IN_IG_STORY",
  POST_IN_GL = "POST_IN_GL",
  POST_IN_ZL = "POST_IN_ZL",
  PLAYER_HASHTAG = "PLAYER_HASHTAG",
  PLAYER_CUSTOM_STICKERS = "PLAYER_CUSTOM_STICKERS",
  COMPLIANCE_DISCLAIMER = "COMPLIANCE_DISCLAIMER",
  PLAYER_MVP_ACCESS = "PLAYER_MVP_ACCESS",
  PLAYER_MVP_THEMES = "PLAYER_MVP_THEMES",
  PLAYER_CALENDAR_ACCESS = "PLAYER_CALENDAR_ACCESS",
  ALLOW_PLAYER_ACCESS_TO_PLAYER_CARDS = "ALLOW_PLAYER_ACCESS_TO_PLAYER_CARDS",
  ALLOW_PLAYER_TO_EDIT_PLAYER_CARD_THEMES = "ALLOW_PLAYER_TO_EDIT_PLAYER_CARD_THEMES",
  AUTO_CREATE_PLAYER_CARDS = "AUTO_CREATE_PLAYER_CARDS",
  CAPTION_COACH = "CAPTION_COACH",
  ALLOW_PLAYER_TO_SCREEN_CAPTURE = "ALLOW_PLAYER_TO_SCREEN_CAPTURE",
  PLAYER_REPUTATION_MANAGEMENT = "PLAYER_REPUTATION_MANAGEMENT",
}
interface AppSetting {
  appSettingId: CoachSettings;
  status: string; // "ACTIVE" | "INACTIVE";
}

export interface CoachAppSetting {
  coachId: string | number;
  settings: AppSetting[];
}

export interface PlayerAppSetting {
  coachId: string;
  playerId: string;
  settings: AppSetting[];
}

export enum WebSettings {
  TIKTOK = "TIKTOK",
  COST_CENTER = "COST_CENTER",
  SC_PLUS_TIER = "SC_PLUS_TIER",
  ACCESS_SCRIPT_LIBRARY = "ACCESS_SCRIPT_LIBRARY",
  MANAGE_SCRIPT_LIBRARY = "MANAGE_SCRIPT_LIBRARY",
  EXCLUDE_GLOBAL_SCRIPTS = "EXCLUDE_GLOBAL_SCRIPTS",
  ALLOW_ACCESS_TO_PLAYER_CARDS = "ALLOW_ACCESS_TO_PLAYER_CARDS",
  PUBLIC_API_ACCESS = "PUBLIC_API_ACCESS",
  SUPER_PAGES = "SUPER_PAGES",
  MENTIONS = "MENTIONS",
  LINK_TRACKING = "LINK_TRACKING",
  REPUTATION_MANAGEMENT = "REPUTATION_MANAGEMENT",
  REQUIRE_QA_ON_VIDEOS = "REQUIRE_QA_ON_VIDEOS",
}

export enum WebComponents {
  PROMPTS = "LIBRARY",
  CAMPAIGNS = "CAMPAIGNS",
  PLAYERS = "PLAYERS",
  CALENDAR = "CALENDAR",
  COMPLIANCE = "COMPLIANCE",
  VIDEO_CATALYST = "VIDEO_CATALYST",
  MANAGE_SCRIPT_LIBRARY = "MANAGE_SCRIPT_LIBRARY",
  ASSISTANTS = "ADMIN",
  ALERTS = "ALERTS",
  DIGEST_EMAIL = "DIGEST_EMAIL",
  APP_SETTINGS = "APP_SETTINGS",
  API_KEYS = "API_MANAGEMENT",
  VIDEO_PAGES = "VIDEO_PAGES",
  PLAYER_CARDS = "PLAYER_CARDS",
  REPUTATION_MANAGEMENT = "REPUTATION_MANAGEMENT",
}

export type CoachComponent = {
  id: WebComponents;
  label: string;
  webSetting: WebSettings | null;
};

export const CoachComponents: Record<WebComponents, CoachComponent> = {
  [WebComponents.PROMPTS]: {
    id: WebComponents.PROMPTS,
    label: "Library - Prompts",
    webSetting: null,
  },
  [WebComponents.MANAGE_SCRIPT_LIBRARY]: {
    id: WebComponents.MANAGE_SCRIPT_LIBRARY,
    label: "Library - Scripts",
    webSetting: WebSettings.MANAGE_SCRIPT_LIBRARY,
  },
  [WebComponents.VIDEO_CATALYST]: {
    id: WebComponents.VIDEO_CATALYST,
    label: "Library - Video Catalyst",
    webSetting: WebSettings.SC_PLUS_TIER,
  },
  [WebComponents.VIDEO_PAGES]: {
    id: WebComponents.VIDEO_PAGES,
    label: "Library - Video Pages",
    webSetting: WebSettings.SUPER_PAGES,
  },
  [WebComponents.PLAYERS]: {
    id: WebComponents.PLAYERS,
    label: "Users - Players",
    webSetting: null,
  },
  [WebComponents.ASSISTANTS]: {
    id: WebComponents.ASSISTANTS,
    label: "Users - Assistants",
    webSetting: null,
  },
  [WebComponents.CAMPAIGNS]: {
    id: WebComponents.CAMPAIGNS,
    label: "Campaigns",
    webSetting: null,
  },
  [WebComponents.CALENDAR]: {
    id: WebComponents.CALENDAR,
    label: "Calendar",
    webSetting: null,
  },
  [WebComponents.COMPLIANCE]: {
    id: WebComponents.COMPLIANCE,
    label: "Compliance",
    webSetting: null,
  },
  [WebComponents.PLAYER_CARDS]: {
    id: WebComponents.PLAYER_CARDS,
    label: "Player Cards",
    webSetting: WebSettings.ALLOW_ACCESS_TO_PLAYER_CARDS,
  },
  [WebComponents.REPUTATION_MANAGEMENT]: {
    id: WebComponents.REPUTATION_MANAGEMENT,
    label: "Reputation",
    webSetting: WebSettings.REPUTATION_MANAGEMENT,
  },
  [WebComponents.ALERTS]: {
    id: WebComponents.ALERTS,
    label: "Alerts",
    webSetting: null,
  },
  [WebComponents.APP_SETTINGS]: {
    id: WebComponents.APP_SETTINGS,
    label: "Settings",
    webSetting: null,
  },
  [WebComponents.DIGEST_EMAIL]: {
    id: WebComponents.DIGEST_EMAIL,
    label: "Settings - Digest Email",
    webSetting: null,
  },
  [WebComponents.API_KEYS]: {
    id: WebComponents.API_KEYS,
    label: "Settings - API Keys",
    webSetting: WebSettings.PUBLIC_API_ACCESS,
  },
};
